import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetNoteDocument,
  GetNoteQueryVariables,
} from '../../types/api/graphql';

export function useAgendaNote(variables: GetNoteQueryVariables) {
  const { data: agendaNoteData, loading: agendaNoteLoading } = useCacheQuery(
    GetNoteDocument,
    {
      variables,
      skip: !variables.healthProviderId,
    }
  );

  const data = useMemo(
    () => agendaNoteData?.note?.text ?? null,
    [agendaNoteData?.note]
  );

  return {
    data,
    loading: agendaNoteLoading,
  };
}
